import React, { createRef } from 'react';
import { useSwitchToVariantImage } from '@jetshop/core/hooks/Product';
import Gallery from './ImageGallery';
import Styled from './Style';

const ImageContainer = ({ images, variant, video, mainimages }) => {
  const galleryRef = createRef();
  // Enable switching gallery to image of selected variant
  useSwitchToVariantImage({
    galleryImages: images,
    galleryRef,
    variant
  });

  return (
    <Styled.ImageContainerWrapper>
      <Gallery
        images={images}
        galleryRef={galleryRef}
        video={video}
        mainimages={mainimages}
      />
    </Styled.ImageContainerWrapper>
  );
};

export default ImageContainer;
